import { defineComponent as _defineComponent } from 'vue'
import { PropType, computed } from "vue";
import PaymentInfoWithSeats from "./PaymentInfoWithSeats.vue";
import PaymentInfoWithoutSeats from "./PaymentInfoWithoutSeats.vue";
import { IDateInfo } from "@/domain/entities/book";
import PaymentInfoFreeWithSeats from "./PaymentInfoFreeWithSeats.vue";
import PaymentInfoFreeWithoutSeats from "./PaymentInfoFreeWithoutSeats.vue";


const __default__ = {
  name: "PaymentInfoSection",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  shouldPay: {
    type: Boolean,
    required: true,
  },
  seatsSelectable: {
    type: Boolean,
    required: true,
  },
  bookingDates: {
    // 예약 진행중인 날짜
    type: Array as PropType<Array<IDateInfo>>,
    default: () => [],
  },
  totalAmount: {
    type: Number,
  },
  oneTimeFare: {
    type: Number,
  },
  currentBookInterval: {
    type: String,
  },
},
  setup(__props, { expose: __expose }) {
  __expose();

const props = __props;

const currentComponent = computed(() => {
  if (props.shouldPay && props.seatsSelectable) {
    return PaymentInfoWithSeats;
  } else if (props.shouldPay && !props.seatsSelectable) {
    return PaymentInfoWithoutSeats;
  } else if (!props.shouldPay && props.seatsSelectable) {
    return PaymentInfoFreeWithSeats;
  } else {
    return PaymentInfoFreeWithoutSeats;
  }
});

const bookingDatesCount = computed(() => props.bookingDates?.length ?? 0);

const __returned__ = { props, currentComponent, bookingDatesCount }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})